module.exports = __webpack_public_path__ + "static/media/mariana-pupo.04eea6d5.jpeg";